// Shared by the editor and backend format resolver. No browser dependencies.
export const FORMAT_LABELS = {
  pdf: 'PDF File', doc: 'Office DOC File', docx: 'Office DOCX File',
  ppt: 'PowerPoint PPT File', pptx: 'PowerPoint PPTX File',
  xls: 'Excel XLS File', xlsx: 'Excel XLSX File',
  odt: 'OpenDocument Text File', ods: 'OpenDocument Spreadsheet', odp: 'OpenDocument Presentation',
  rtf: 'RTF File', txt: 'Text File', csv: 'CSV File',
  jpg: 'JPEG Image', png: 'PNG Image', svg: 'SVG Image', webp: 'WebP Image',
  mp3: 'MP3 Audio', wav: 'WAV Audio', mp4: 'MP4 Video',
  application: 'Application', other: 'Other Format',
  zip: 'ZIP archive', rar: 'RAR archive', '7z': '7Z archive',
};
const MIME_FORMATS = {
  'application/pdf': 'pdf', 'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.oasis.opendocument.text': 'odt',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.oasis.opendocument.presentation': 'odp',
  'application/rtf': 'rtf', 'text/rtf': 'rtf', 'text/plain': 'txt', 'text/csv': 'csv',
  'image/jpeg': 'jpg', 'image/png': 'png', 'image/svg+xml': 'svg', 'image/webp': 'webp',
  'audio/mpeg': 'mp3', 'audio/wav': 'wav', 'video/mp4': 'mp4',
  'application/zip': 'zip', 'application/x-zip-compressed': 'zip',
  'application/vnd.rar': 'rar', 'application/x-rar-compressed': 'rar',
  'application/x-7z-compressed': '7z',
};
export const isArchiveFormat = (format) => ['zip', 'rar', '7z'].includes(format);
export function detectResourceFormat(file) {
  const mime = String(file.mimeType || file.type || '').toLowerCase().split(';')[0].trim();
  // Prefer specific MIME metadata, then original filename, then legacy stored path.
  if (MIME_FORMATS[mime]) return MIME_FORMATS[mime];
  const ext = String(file.originalName || file.name || file.path || '').split(/[?#]/)[0].split('.').pop().toLowerCase();
  const normalized = ext === 'jpeg' ? 'jpg' : ext;
  return FORMAT_LABELS[normalized] ? normalized : 'other';
}
export function resolveResourceFormats(saved, detected) {
  return [...new Set(saved?.length ? saved : detected)];
}
